import React, { useState } from "react";

export default function TemplateFilter({
  search,
  setSearch,
  searchType,
  setSearchType,
  handleSearch
}) {
  const [searchTypeDropdownOpen, setSearchTypeDropdownOpen] = useState(false);

  const searchTypes = [
    { value: "title", label: "제목" },
    { value: "writer", label: "내용" },
  ];

  const selectedSearchType =
    searchTypes.find((item) => item.value === searchType)?.label || "제목";

  return (
    <div className="central-template-filter">
      <div className="central-template-filter-right">
        <div className="central-template-dropdown">
          <button
            className="central-template-dropdown-btn"
            onClick={() => setSearchTypeDropdownOpen((v) => !v)}
            type="button"
          >
            {selectedSearchType}
            <svg
              width="14"
              height="8"
              viewBox="0 0 24 12"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              style={{
                transform: searchTypeDropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s"
              }}
            >
              <polyline points="2 2 12 10 22 2" />
            </svg>
          </button>

          {searchTypeDropdownOpen && (
            <ul className="central-template-dropdown-list">
              {searchTypes.map((item) => (
                <li
                  key={item.value}
                  className={`central-template-dropdown-item ${searchType === item.value ? "active" : ""}`}
                  onClick={() => {
                    setSearchType(item.value);
                    setSearchTypeDropdownOpen(false);
                  }}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="central-template-search-wrap">
          <input
            className="central-template-search-input"
            type="text"
            placeholder="검색어를 입력하세요."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
          <button className="central-template-search-btn" onClick={handleSearch}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </button>
        </div>

      </div>
    </div>
  );
}